/**
 * @license @tabler/icons-react v3.34.1 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

const __iconNode = [["path", { "d": "M7 10v4h3v7h4v-7h3l1 -4h-4v-2a1 1 0 0 1 1 -1h3v-4h-3a5 5 0 0 0 -5 5v2h-3", "key": "svg-0" }]];
const IconBrandFacebook = createReactComponent("outline", "brand-facebook", "BrandFacebook", __iconNode);

export { __iconNode, IconBrandFacebook as default };
//# sourceMappingURL=IconBrandFacebook.mjs.map
